import { render, staticRenderFns } from "./NearestNeighbors.vue?vue&type=template&id=515904b9&scoped=true&"
import script from "./NearestNeighbors.vue?vue&type=script&lang=js&"
export * from "./NearestNeighbors.vue?vue&type=script&lang=js&"
import style0 from "./NearestNeighbors.vue?vue&type=style&index=0&id=515904b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515904b9",
  null
  
)

component.options.__file = "NearestNeighbors.vue"
export default component.exports